import FormSuggested from './FormSuggested'
export default FormSuggested
